import { render, staticRenderFns } from "./5_m_location.vue?vue&type=template&id=8f672c9c&scoped=true&"
import script from "./5_m_location.vue?vue&type=script&lang=js&"
export * from "./5_m_location.vue?vue&type=script&lang=js&"
import style0 from "./5_m_location.vue?vue&type=style&index=0&id=8f672c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f672c9c",
  null
  
)

export default component.exports